import { render, staticRenderFns } from "./IconCredit.vue?vue&type=template&id=b119b648&scoped=true&"
import script from "./IconCredit.vue?vue&type=script&lang=js&"
export * from "./IconCredit.vue?vue&type=script&lang=js&"
import style0 from "./IconCredit.vue?vue&type=style&index=0&id=b119b648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b119b648",
  null
  
)

export default component.exports